import React from 'react';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { Home } from '../SubPages/Home/Home';
import { Privacy } from '../SubPages/Privacy/Privacy';

function Index() {
  return (
    <Routes>
      <Route path={'/'} element={<Home />} />
      <Route path={'Privacy'} element={<Privacy />} />
    </Routes>
  );
}

export { Index };
